import { Switch } from "@/components/ui/switch";
import { Globe } from "lucide-react";
import { PoweredByPerplexity } from "@/shared/components/PoweredByPerplexity";

interface UseWebSearchToggleProps {
  includeWeb: boolean;
  setIncludeWeb: (value: boolean) => void;
  disabled?: boolean;
}

export function UseWebSearchToggle({
  includeWeb,
  setIncludeWeb,
  disabled = false,
}: UseWebSearchToggleProps) {
  return (
    <div
      onClick={() => !disabled && setIncludeWeb(!includeWeb)}
      className={`w-full transition-colors cursor-pointer
             ${includeWeb ? "bg-blue-50 border-blue-200" : "bg-gray-50 border-gray-200"} 
             border-2 rounded-lg p-4 hover:bg-blue-50/70 group
             ${disabled ? "cursor-not-allowed opacity-50" : ""}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div
            className={`p-2 rounded-lg ${includeWeb ? "bg-blue-100" : "bg-gray-100"}`}
          >
            <Globe
              className={`h-5 w-5 ${includeWeb ? "text-blue-600" : "text-gray-600"}`}
            />
          </div>
          <div className="text-left">
            <div className="flex items-center gap-2">
              <h3
                className={`font-medium ${includeWeb ? "text-blue-900" : "text-gray-900"}`}
              >
                Web and News Access
              </h3>
              <PoweredByPerplexity />
            </div>
            <p
              className={`text-sm ${includeWeb ? "text-blue-600" : "text-gray-600"}`}
            >
              Quantly will search the web for relevant information and news
            </p>
          </div>
        </div>
        <Switch
          checked={includeWeb}
          onCheckedChange={setIncludeWeb}
          className={includeWeb ? "bg-blue-500" : ""}
          disabled={disabled}
        />
      </div>
    </div>
  );
}
